import React, { useState } from 'react';
import './style.less';
import { ModalProps } from 'antd/lib/modal';
import { Divider, Modal } from 'antd';
import { Button } from 'shared/components/Button';
import { ProspectPropertiesSettings } from './ProspectPropertiesSettings';
import { useDispatch } from 'react-redux';
import { setOrgProspectProperties, updateOrgSettings } from 'shared/store/org-slice';
import { OrgProspectPropertyWithMeta } from 'types/user';

interface ExtraProps {
  onOk: () => void;
  onCancel: () => void;
}

export const ProspectPropertiesModal: React.FC<ModalProps & ExtraProps> = props => {
  const [prospectProperties, setProspectProperties] = useState<
    OrgProspectPropertyWithMeta[]
  >([]);
  const dispatch = useDispatch();

  async function handleSave() {
    const outboundOrgProspectProperties = prospectProperties
      .filter(property => property.propertyGroup && property.propertyKey)
      .map(property => ({
        propertyKey: property.propertyKey,
        propertyGroup: property.propertyGroup,
        label: property.label,
      }));

    dispatch(
      updateOrgSettings({
        outboundProspectProperties: outboundOrgProspectProperties,
      }),
    );
    dispatch(setOrgProspectProperties(outboundOrgProspectProperties));

    if (props.onOk) {
      props.onOk();
    }
  }

  const handleProspectPropertiesChange = (
    prospectProperties: OrgProspectPropertyWithMeta[],
  ) => {
    setProspectProperties(prospectProperties);
  };

  return (
    <Modal visible closable={false} className="ProspectPropertiesModal">
      <div className="ProspectPropertiesModal__header">
        <p className="ProspectPropertiesModal__title">Contact Preview</p>
        <Divider />
      </div>
      <div className="ProspectPropertiesModal__content">
        <div className="ProspectPropertiesModal__content-row">
          <p>Manage and the information that appears on the sidebar</p>
        </div>
        <div className="ProspectPropertiesModal__content-row">
          <ProspectPropertiesSettings
            isStandalone={false}
            onChange={handleProspectPropertiesChange}
          />
        </div>
      </div>
      <Divider />
      <div className="ProspectPropertiesModal__footer">
        <Button type="text" onClick={props.onCancel}>
          Cancel
        </Button>
        <Button type="primary" onClick={handleSave}>
          Save
        </Button>
      </div>
    </Modal>
  );
};
